import {Injectable} from '@angular/core';
import {PaymentTransactionService} from "./payment-transaction.service";
import {PaymentTransactionRequest} from "../models/paymentTransactionRequest";
import {PaymentMethod} from "../enums/paymentMethod";
import {UserCardResponse} from "../interface/userCardResponse";
import {PaymentTransactionResponse} from "../interface/paymentTransactionResponse";
import {WITH_COMMISSION, WITHOUT_COMMISSION} from "../constants/payment.constant";
import {MockupDataModel} from "../qr-copy-message/mockup-data.model";
import {SnackBarUtil} from "../qr-copy-message/snack-bar-util.service";
import {DUPLICATE_MONEY_LUX_UUID_MESSAGE} from "../constants/global.constants";
import {PaymentTransactionUtil} from "../utilityClass/paymentTransactionUtil";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: "root"
})
export class IdramService {

  constructor(
    private snackBar: SnackBarUtil,
    private http: HttpClient,
    private translate: TranslateService
  ) {
  }

  private readonly apiUrl = environment.apiUrl;

  initPayment(userCard: UserCardResponse, amount: string, product: string, isCommissionActive: boolean, moneyLuxUuid: string | null) {
    const userCardId: string = `${userCard.cardId}-`;
    const description: string = "Transfer money to user";
    const paymentTransactionRequest: PaymentTransactionRequest = this.preparePaymentTransactionRequest(description, userCard, userCardId, amount, moneyLuxUuid, null, product);

    this.init(paymentTransactionRequest, isCommissionActive).subscribe({
      next: (htmlForm: string) => {
        this.processResponse(htmlForm);
      },
      error: (error) => {
        if (error.status === 511 && error.error && error.error.message) {
          this.showSnackbar(MockupDataModel.error(DUPLICATE_MONEY_LUX_UUID_MESSAGE), SnackBarUtil.CLASSES.error);
        } else {
          const msg = this.translate.instant('payment_execution_error');
          this.showSnackbar(MockupDataModel.error(msg), SnackBarUtil.CLASSES.error);
        }
      },
    });
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBar.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data,
    });
  }

  initForProductBuying(amount: number, orderId: number) {
    const description: string = 'Product buying';
    const paymentTransactionRequest: PaymentTransactionRequest = new PaymentTransactionRequest(PaymentMethod.IDRAM, description, null, null, amount, 1, null, 0, null, orderId);

    this.init(paymentTransactionRequest, false).subscribe({
      next: (htmlForm: string) => {
        this.processResponse(htmlForm);
      }
    });
  }

  private processResponse(htmlString: string) {
    document.open();
    document.write(htmlString);
    document.close();
  }

  private preparePaymentTransactionRequest(description: string, userCard: UserCardResponse, userCardId: string, price: string, moneyLuxUuid: string | null, productOrderId: number | null, product: string | null) {
    return new PaymentTransactionRequest(
      PaymentMethod.IDRAM,
      description,
      userCard.userId,
      userCardId,
      Number(price),
      1,
      userCard.cardId,
      0,
      moneyLuxUuid,
      productOrderId,
      product
    );
  }

  init(paymentTransactionRequest: PaymentTransactionRequest, isCommissionActive: boolean): Observable<string> {
    const url = `${this.apiUrl}/idram/init?isCommissionActive=${isCommissionActive}`;
    return this.http.post(url, paymentTransactionRequest, {responseType: 'text'});
  }
}
